import { render, staticRenderFns } from "./work_item_notes_loading.vue.js?vue&type=template&id=9a081862!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_notes_loading.vue?vue&type=template&id=9a081862"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports